import { HonorariumPreLiquidationStatusId } from '../../dto/HonorariumPreLiquidationDTO';

interface PreLiquidationStatusTagProps {
    statusId: number;
    /** Descripción del estado que manda el backend ("Activa", "Completada"). */
    status: string;
}

/** Estado de la pre-liquidación (DS §3.4): activa = pendiente de liquidar, completada = todo liquidado. */
export default function PreLiquidationStatusTag({ statusId, status }: PreLiquidationStatusTagProps) {
    const variant = statusId === HonorariumPreLiquidationStatusId.COMPLETED ? 'md-tag-ok' : 'md-tag-warn';
    return <span className={`md-tag ${variant}`}>{status}</span>;
}
